// extracted by mini-css-extract-plugin
module.exports = {"messageHolder":"SelectChemicals_messageHolder__2egUA","nameWrapper":"SelectChemicals_nameWrapper__2DpsN"};